import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b49dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "percentage-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createBlock(_component_el_progress, {
    type: "dashboard",
    percentage: _ctx.percentage,
    width: 80
  }, {
    default: _withCtx(({ percentage }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(percentage) + "%", 1)
    ]),
    _: 1
  }, 8, ["percentage"]))
}